export const variants = {
  primary: {
    active: {
      background: 'hero.plum',
      border: 'hero.plum',
      text: 'text.lightest',
    },
  },
  secondary: {
    active: {
      background: 'background.lightest',
      border: 'background.lightest',
      text: 'hero.plum',
    },
  },
  yellow: {
    active: {
      background: 'secondary.yellow',
      border: 'secondary.yellow',
      text: 'hero.plum',
    },
  },
  lilac: {
    active: {
      background: 'hero.lilac',
      border: 'hero.lilac',
      text: 'hero.plum',
    },
  },
  cancel: {
    active: {
      background: 'text.lightest',
      border: 'hero.red',
      text: 'status.errorPrimary',
    },
  },
};
